__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "container";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@fortawesome/fontawesome-svg-core", "6.5.1", () => (__webpack_require__.e(3636).then(() => (() => (__webpack_require__(3636))))));
			register("@fortawesome/free-solid-svg-icons", "6.5.1", () => (__webpack_require__.e(9417).then(() => (() => (__webpack_require__(9417))))));
			register("@fortawesome/pro-solid-svg-icons", "6.5.2", () => (__webpack_require__.e(3582).then(() => (() => (__webpack_require__(3582))))));
			register("@fortawesome/react-fontawesome", "0.2.0", () => (__webpack_require__.e(7814).then(() => (() => (__webpack_require__(7814))))));
			register("@growthbook/growthbook-react", "0.19.0", () => (() => (__webpack_require__(7106))), 1);
			register("@hookform/resolvers", "2.9.10", () => (__webpack_require__.e(2564).then(() => (() => (__webpack_require__(5851))))));
			register("@lottiefiles/react-lottie-player", "3.5.3", () => (__webpack_require__.e(9879).then(() => (() => (__webpack_require__(9879))))));
			register("@sentry/react", "7.86.0", () => (__webpack_require__.e(3783).then(() => (() => (__webpack_require__(3783))))));
			register("@tanstack/query-core", "4.29.5", () => (__webpack_require__.e(964).then(() => (() => (__webpack_require__(964))))));
			register("@tanstack/query-core", "5.31.0", () => (__webpack_require__.e(300).then(() => (() => (__webpack_require__(300))))));
			register("@tanstack/react-query-devtools", "4.29.5", () => (__webpack_require__.e(41).then(() => (() => (__webpack_require__(41))))));
			register("@tanstack/react-query", "4.29.5", () => (__webpack_require__.e(3109).then(() => (() => (__webpack_require__(3109))))));
			register("axios", "1.6.2", () => (__webpack_require__.e(2632).then(() => (() => (__webpack_require__(2632))))));
			register("bowser", "2.11.0", () => (__webpack_require__.e(1206).then(() => (() => (__webpack_require__(1206))))));
			register("chart.js", "4.4.1", () => (__webpack_require__.e(9449).then(() => (() => (__webpack_require__(9449))))));
			register("country-flag-emoji-polyfill", "0.1.8", () => (__webpack_require__.e(8457).then(() => (() => (__webpack_require__(8457))))));
			register("flickity", "2.3.0", () => (__webpack_require__.e(2442).then(() => (() => (__webpack_require__(2442))))));
			register("form-data", "4.0.0", () => (__webpack_require__.e(6230).then(() => (() => (__webpack_require__(6230))))));
			register("frames-react", "1.1.0", () => (__webpack_require__.e(2176).then(() => (() => (__webpack_require__(2176))))));
			register("jotai-tanstack-query", "0.8.5", () => (__webpack_require__.e(1326).then(() => (() => (__webpack_require__(1326))))));
			register("jotai", "2.6.0", () => (__webpack_require__.e(3598).then(() => (() => (__webpack_require__(3562))))));
			register("js-cookie", "3.0.5", () => (__webpack_require__.e(1955).then(() => (() => (__webpack_require__(1955))))));
			register("lottie-react", "2.4.0", () => (__webpack_require__.e(9260).then(() => (() => (__webpack_require__(9260))))));
			register("moment", "2.29.4", () => (__webpack_require__.e(381).then(() => (() => (__webpack_require__(381))))));
			register("react-chartjs-2", "5.2.0", () => (__webpack_require__.e(6495).then(() => (() => (__webpack_require__(6495))))));
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(3935))), 1);
			register("react-error-boundary", "4.0.11", () => (__webpack_require__.e(4511).then(() => (() => (__webpack_require__(4511))))));
			register("react-flickity-component", "4.0.6", () => (__webpack_require__.e(9612).then(() => (() => (__webpack_require__(9612))))));
			register("react-helmet-async", "1.3.0", () => (__webpack_require__.e(405).then(() => (() => (__webpack_require__(405))))));
			register("react-hook-form", "7.49.0", () => (__webpack_require__.e(7536).then(() => (() => (__webpack_require__(7536))))));
			register("react-joyride", "2.5.3", () => (__webpack_require__.e(9856).then(() => (() => (__webpack_require__(9856))))));
			register("react-qrcode-logo", "2.9.0", () => (__webpack_require__.e(5718).then(() => (() => (__webpack_require__(5718))))));
			register("react-router-dom", "6.20.1", () => (() => (__webpack_require__(9818))), 1);
			register("react", "17.0.2", () => (() => (__webpack_require__(1147))), 1);
			register("react", "18.2.0", () => (() => (__webpack_require__(7294))), 1);
			register("wonka", "6.3.4", () => (__webpack_require__.e(3496).then(() => (() => (__webpack_require__(3496))))));
			register("yup", "1.3.2", () => (__webpack_require__.e(6310).then(() => (() => (__webpack_require__(6310))))));
			initExternal(2689);
			initExternal(6022);
			initExternal(4102);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};